exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".form-customer-terms {\n  margin-top: 1.8rem; }\n  .form-customer-terms .link {\n    color: #8b3187;\n    cursor: pointer;\n    font-weight: 600; }\n  .form-customer-terms .refund {\n    padding-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/FormCustomerTerms/FormCustomerTerms.scss
// module id = 1456
// module chunks = 0